import {GET_FOOD_CATEGORIES} from "../actions/foodCategories";

export default function(state = {}, action) {
    switch (action.type) {
        case GET_FOOD_CATEGORIES:
            return { ...state, ...action.payload.results };
        default:
            return state;
    }
}



// WEBPACK FOOTER //
// ./src/store/reducers/foodCategories.js